/**
 * Shared constants for the Models module.
 * Single source of truth for colors, limits, and lookup maps
 * used across model pages, components, and hooks.
 */

// Color palette for material components in the model builder
export const MATERIAL_COLORS = [
  '#B87333', '#C0C0C0', '#71797E', '#E5E4E2',
  '#ADD8E6', '#FFD700', '#CD7F32', '#8B4513',
];

// Colors assigned to comparison overlays — one per comparison slot
export const COMPARISON_COLORS = ['#3B82F6', '#10B981', '#F97316'];

// Blue → teal → cyan palette for classification and sources pie charts
export const CLASSIFICATION_COLORS = [
  '#2563EB', // blue-600        (dominant, large segments)
  '#0F766E', // teal-700        (dark teal)
  '#BAE6FD', // sky-200         (very light blue)
  '#06B6D4', // cyan-500        (bright cyan)
  '#1D4ED8', // blue-700        (deeper blue)
  '#134E4A', // teal-900        (very dark teal)
  '#7DD3FC', // sky-300         (light sky blue)
  '#0891B2', // cyan-600        (mid cyan)
  '#DBEAFE', // blue-100        (pale blue)
  '#0284C7', // sky-600
  '#164E63', // cyan-900
  '#E0F2FE', // sky-100         (near-white blue)
];

// Maximum number of simultaneous chart comparisons
export const MAX_COMPARISONS = 3;

// Number of filled/unfilled bars in the market stability indicator
export const STABILITY_BARS = 4;

// Sort weight for regulatory impact levels (High first, ascending order)
export const IMPACT_SORT_ORDER = { High: 0, Medium: 1, Mid: 1, Low: 2 };

// Maps impact level to badge color token used by RegulatoryInsightCard
export const IMPACT_BADGE_COLOR = { High: 'red', Medium: 'yellow', Mid: 'yellow', Low: 'green' };
